import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";
import brandImage from "assets/img/iese-logo-navbar.png";
import SnackbarContent from "components/Snackbar/SnackbarContent";
import { useTranslation } from 'react-i18next';
import ClipLoader from "react-spinners/ClipLoader";
import Axios from "axios";
import config from "assets/config/config.json";

import AnyQuestionsComponent from "components/MyComponents/AnyQuestionsComponent";
import { withRouter } from "react-router-dom";
import DigitalIdDetail from "components/DigitalIdDetail/DigitalIdDetail";


const useStyles = makeStyles(styles);

function LandingPage(props) {
  const { history } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const { ...rest } = props;
  const [error, setError] = React.useState(null);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [items, setItems] = React.useState(null);

  console.log('Main page logic entered');
  function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  eraseCookie("returndigitalid");
  // Note: the empty deps array [] means
  // this useEffect will run once
  // similar to componentDidMount()
  React.useEffect(() => {
    Axios.get(config.checklogin)
      .then(
        (_result) => {
          Axios.get(config.getQuote)
            .then(
              (result) => {
                if (result.data && !result.data.isExempt && result.data.isnotsubscribed) {
                  history.replace('/personalinformation');
                } else {
                  setItems(result.data);
                  setIsLoaded(true);
                }
              },
              (error) => {
                setIsLoaded(true);
                setError(error);
              })
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setIsLoaded(false);
          setError(error);
        }
      )
  }, []);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (error && error.response && error.response.status === 403) {
    setCookie("returndigitalid", "1", 1);
    history.replace('/auth');
    window.location.reload();
    console.log('MainPage: Error status 403');
  }
  else if (error) {
    history.replace('/help');
    window.location.reload();
    console.log('MainPage: Generic error');
  }
  else if (!isLoaded) {
    console.log('MainPage: Not Loaded');
    return (
      <div>
    <Header key={1}
          color="dark"
          sticky
          breadcrumb={[{ text: t("OverviewLiteral"), selected: true, isbutton: true, path: "/" }, { text: t("PaymentMethod"), selected: false, isbutton: true, path: "/paymentoverview" }]}
          userData={null}
          {...rest}
        />
      <div
        style={{
          position: 'absolute', left: '50%', top: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <ClipLoader

          size={200}
          color={"#504a4a"}
        />
      </div></div>);
  }
  else {
    console.log('MainPage: Show Import');
    let breadcrumbItems = [];
    if (items && items.isExempt) {
      breadcrumbItems = [{ text: t("OverviewLiteral"), selected: true, isbutton: true, path: "/" }];
    } else {
      breadcrumbItems = [{ text: t("OverviewLiteral"), selected: true, isbutton: true, path: "/" }, { text: t("PaymentMethod"), selected: false, isbutton: true, path: "/paymentoverview" }];
    }
    
    return (
      <div>
        <Header key={2}
          color="dark"
          sticky
          brand={<img style={{ filter: "brightness(0) invert(1)" }}
              src={brandImage}
              className={classes.img}
              alt="brand"
          />}
          userData={items}
          breadcrumb={breadcrumbItems}
          {...rest}
          myprofile
        />
        <SnackbarContent
          message={
            <span>
              <b>{t("Alert") + ':'}</b> {t("AlertText")}
            </span>
          }
          id="notification"
          color="warning"
          icon="info_outline"
          close
        />
        <SnackbarContent
          message={
            <span style={{ padding: "10px 0" }}>
              {t("Fields")}
            </span>
          }
          id="info"
          color="danger"
          icon="info_outline"
          close
        />
        <SnackbarContent
          message={
            <span>
              {t("ServerError")}
            </span>
          }
          id="error"
          color="danger"
          icon="info_outline"
          close
        />
        <DigitalIdDetail userData={items} />
        <AnyQuestionsComponent />
        <Footer whiteFont />
      </div>

    );
  }
}
export default withRouter(LandingPage);